import { defineComponent as _defineComponent } from 'vue'
import { computed, useSlots } from 'vue'

type TailAlign = 'left' | 'center' | 'right'
type TooltipWidth = 'sm' | 'md' | 'lg' | 'xl'


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomTooltip',
  props: {
    heading: { default: '' },
    text: { default: '' },
    html: { default: '' },
    linkText: { default: '' },
    linkHref: { default: '' },
    placement: { default: 'top' },
    distance: { default: 12 },
    theme: { default: 'brand-bubble' },
    tailAlign: { default: 'center' },
    width: { default: 'md' },
    widthClassOverride: { default: '' },
    ariaLabel: { default: 'More information' },
    icon: { default: () => ['fas', 'circle-info'] },
    bubbleIcon: { default: null },
    bubbleImageProvider: { default: 'cloudinary' },
    bubbleImageSrc: { default: '' },
    bubbleImageFallback: { default: '' },
    bubbleImageAlt: { default: '' },
    triggerButtonClass: { default: 'text-stone-400 hover:text-stone-400' },
    triggerIconClass: { default: 'custom-tooltip-trigger-icon' },
    triggerClass: { default: '' },
    triggers: { default: () => ['hover', 'focus'] },
    popperTriggers: { default: () => ['hover', 'focus'] },
    delay: { default: () => ({ show: 0, hide: 200 }) }
  },
  emits: ["link-click"],
  setup(__props: any) {

const props = __props as { heading: string, text: string, html: string, linkText: string, linkHref: string, placement: string, distance: number, theme: string, tailAlign: TailAlign, width: TooltipWidth, widthClassOverride: string, ariaLabel: string, icon: [string, string], bubbleIcon: [string, string] | null, bubbleImageProvider: string, bubbleImageSrc: string, bubbleImageFallback: string, bubbleImageAlt: string, triggerButtonClass: string, triggerIconClass: string, triggerClass: string, triggers: string[], popperTriggers: string[], delay: { show: number; hide: number } }





const slots = useSlots()

const hasBubbleVisual = computed(() => Boolean(props.bubbleImageSrc || props.bubbleIcon))

const shouldRenderBubbleIcon = computed(() => {
  return Boolean(slots.icon || hasBubbleVisual.value || resolvedBubbleIcon.value)
})

const resolvedBubbleIcon = computed<[string, string]>(() => {
  return props.bubbleIcon || ['fas', 'circle-info']
})

const widthClass = computed(() => {
  if (props.widthClassOverride) {
    return props.widthClassOverride
  }

  switch (props.width) {
    case 'sm':
      return 'w-[320px] max-w-[calc(100vw-32px)]'
    case 'lg':
      return 'w-[560px] max-w-[calc(100vw-32px)]'
    case 'xl':
      return 'w-[640px] max-w-[calc(100vw-32px)]'
    default:
      return 'w-[480px] max-w-[calc(100vw-32px)]'
  }
})

const tailPositionClass = computed(() => {
  switch (props.tailAlign) {
    case 'left':
      return 'left-[72px] -translate-x-1/2'
    case 'right':
      return 'right-[72px]'
    default:
      return 'left-1/2 -translate-x-1/2'
  }
})

const tailOrientationClass = computed(() => {
  // bottom: tail points up onto the page's light background. The clip-path crops
  // the tail's own box-shadow, and there's no body shadow above to reinforce it
  // (the body shadow is downward-only), so it needs a stronger, upward shadow than
  // the top case (which sits over the tooltip body and reads fine at 5%).
  return props.placement?.startsWith('bottom')
    ? 'top-[-10px] bottom-auto shadow-[-6px_-6px_16px_rgb(16_24_40_/_15%)]'
    : 'bottom-[-10px]'
})

return { __sfc: true,props, slots, hasBubbleVisual, shouldRenderBubbleIcon, resolvedBubbleIcon, widthClass, tailPositionClass, tailOrientationClass }
}

})